<template>
  <div class="container">
    <div class="box">
      <div class="columns">
        <div class="column is-12">
          <!-- the form buttons -->
          <button type="submit" class="button is-success" @click="updateProperty('published')">Publish</button>
          <button type="submit" class="button is-info" @click="updateProperty('saved')">Save Draft</button>
          <router-link to="/admin/properties" class="button is-danger">Cancel</router-link>
        </div>
      </div>

      <div class="columns is-multiline" v-if="property">
        <div class="column is-8">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="field">
                <label class="label">Name</label>
                <div class="control">
                  <input type="text" class="input" placeholder="Title" v-model="property.name">
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <label class="label">Tagline</label>
                <div class="control">
                  <input type="text" class="input" placeholder="Title" v-model="property.tagline">
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <label class="label">About</label>
                <div class="control">
                  <!-- rich text vue-quill-editor plugin -->
                  <quill-editor v-model="property.about" :options="editorOptions">
                  </quill-editor>
                  <input type="file" id="getImage" style="display: none;" @change="uploadImage">
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <label class="label">Type</label>
                <div class="control">
                  <input type="text" class="input" placeholder="Title" v-model="property.type">
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <p class="heading">Location</p>
                <div class="control has-icons-left">
                  <div class="select">
                    <select v-model="property.location">
                      <option value="null">Select Location</option>
                      <option v-for="location in locations" :key="location['.key']" :value="location['.key']">{{location.name}}</option>
                    </select>
                  </div>
                  <div class="icon is-small is-left">
                    <i class="fa fa-map"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="level">
                <div class="level-left">
                  <div class="level-item">
                    <div>
                      <p class="heading">Check out</p>
                      <input-time v-model="property.checkOutTime"/>
                    </div>
                  </div>
                  <div class="level-item">
                    <div>
                      <p class="heading">Check In</p>
                      <input-time v-model="property.checkInTime"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="field">
                <div class="control">
                  <label class="label">Featured Image</label>
                  <figure class="image is-5by4" v-if="property.featuredImage">
                    <featured-image :mediaId="property.featuredImage"></featured-image>
                  </figure>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <div class="file">
                    <label class="file-label">
                      <input @change="uploadImages" class="file-input" type="file" name="resume"
                             accept=".jpg, .jpeg, .png"/>
                      <span class="file-cta">
                      <span class="file-icon">
                        <i class="fa fa-upload"></i>
                      </span>
                      <span class="file-label">
                        Choose a Featured Image…
                      </span>
                    </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="field">
                <p class="heading">Property Gallery</p>
                <div class="control has-icons-left">
                  <div class="select">
                    <select v-model="property.gallery">
                      <option value="null">Select Gallery</option>
                      <option v-for="gallery in galleries" :key="gallery['.key']" :value="gallery['.key']">{{gallery.title}}</option>
                    </select>
                  </div>
                  <div class="icon is-small is-left">
                    <i class="fa fa-picture-o"></i>
                  </div>
                </div>
              </div>
              <div class="field">
                <p class="heading">Hero Banner</p>
                <div class="control has-icons-left">
                  <div class="select">
                    <select v-model="property.heroGallery">
                      <option value="null">Select Gallery</option>
                      <option v-for="gallery in galleries" :key="gallery['.key']" :value="gallery['.key']">{{gallery.title}}</option>
                    </select>
                  </div>
                  <div class="icon is-small is-left">
                    <i class="fa fa-picture-o"></i>
                  </div>
                </div>
              </div>
              <AddressEditPanel :value="property.address" @input="updateAddress"></AddressEditPanel>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <hr>

          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <h5>Amenities</h5>
              </div>
              <div class="level-item">
                <button class="button" @click="addAmenity()">Add Amenity</button>
              </div>
            </div>
          </div>

          <div class="columns is-multiline">
            <div v-for="(amenity, key) in property.amenities" class="column is-full-mobile is-half-tablet is-one-third-desktop is-one-third-widescreen is-one-quarter-fullhd" :key="key">
              <service-edit-card :service="amenity">
                <template slot="footer">
                  <button class="button is-small is-outlined is-danger" @click="deleteAmenity(key)">
                    Delete &nbsp;
                    <span class="icon is-small">
                      <i class="fas fa-times"></i>
                    </span>
                  </button>
                </template>
              </service-edit-card>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <hr>

          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <h5>Services</h5>
              </div>
              <div class="level-item">
                <button class="button" @click="addService()">Add Service</button>
              </div>
            </div>
          </div>

          <div class="columns is-multiline">
            <div v-for="(service, key) in property.services" class="column is-full-mobile is-half-tablet is-one-third-desktop is-one-third-widescreen is-one-quarter-fullhd" :key="key">
              <service-edit-card :service="service">
                <template slot="footer">
                  <button class="button is-small is-outlined is-danger" @click="deleteService(key)">
                    Delete &nbsp;
                    <span class="icon is-small">
                      <i class="fas fa-times"></i>
                    </span>
                  </button>
                </template>
              </service-edit-card>
            </div>
          </div>
        </div>
      </div>

      <!-- notification -->
      <transition mode="out-in" name="fade">
        <div v-if="notification.message" :class="'notification is-' + notification.type">
          <button class="delete" @click="hideNotifications"></button>
          {{notification.message}}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import {mediaRef, propertiesRef, galleriesRef, locationsRef} from '@/firebase_config'
import notifier from '@/mixins/notifier'
import editorOptions from './editor-options'
import imageLoader from '@/mixins/image-loader'

import ServiceEditCard from './ServiceEditCard'
import inputTime from '../../common/inputTime'
import FeaturedImage from '../../common/FeaturedImage'
import AddressEditPanel from '../../common/AddressEditPanel'

export default {
  name: 'user-property-edit',
  data () {
    return {
      currentUser: firebase.auth().currentUser,
      property: null,
      editorOptions
    }
  },
  firebase: {
    media: mediaRef,
    galleries: galleriesRef,
    locations: locationsRef
  },
  mixins: [imageLoader, notifier],
  methods: {
    updateProperty (state) {
      this.property.state = state
      let tempData = {
        ...this.property,
        createdBy: this.currentUser.uid,
        createdOn: (new Date()).toISOString()
      }
      propertiesRef.child(this.$route.params.key).set(tempData).then(() => {
        if (state === 'saved') {
          this.showNotification('success', 'Property updated successfully')
        }
        if (state === 'published') {
          this.showNotification('success', 'Property updated and published successfully')
        }
      })
    },
    uploadImages (e) {
      let files = e.target.files
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        this.uploadImage(file)
      }
    },
    uploadImage (file) {
      let storageRef = firebase.storage().ref('images/properties/' + file.name)
      let uploadTask = storageRef.put(file)

      uploadTask.then(this.addImageToMedia)
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, this.handleUploadProgress, this.handleUploadError, this.handleUploadComplete)
    },
    handleUploadProgress (snapshot) {
      let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      this.showNotification('success', 'Uploading image ' + Math.floor(progress) + '% done.')

      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log('Upload is paused')
          break
        case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log('Upload is running')
          break
      }
    },
    handleUploadError (error) {
      switch (error.code) {
        case 'storage/unauthorized':
          console.log('storage/unauthorized')
          // User doesn't have permission to access the object
          break
        case 'storage/canceled':
          console.log('storage/canceled')
          // User canceled the upload
          break
        case 'storage/unknown':
          console.log('storage/unknown')
          // Unknown error occurred, inspect error.serverResponse
          break
        default:
          console.log(error)
      }
    },
    handleUploadComplete () {
      console.log('Upload Complete!')
    },
    addImageToMedia (snapshot) {
      this.showNotification('success', snapshot.metadata.name + ' uploaded.')
      let mediaObj = {
        src: snapshot.downloadURL,
        path: snapshot.ref.fullPath,
        name: snapshot.metadata.name,
        contentType: snapshot.metadata.contentType,
        createdBy: this.currentUser.uid,
        createdOn: (new Date()).toISOString()
      }

      mediaRef.push(mediaObj).then(ref => {
        this.property.featuredImage = ref.key
      })
    },
    addAmenity () {
      let newAmenity = {
        description: '',
        free: false
      }
      let p = propertiesRef.child(this.$route.params.key).child('amenities').push(newAmenity)
      p.then(payload => {
        this.addAmenityKeyToProperty(payload.key, newAmenity)
      })
    },
    deleteAmenity (key) {
      this.$delete(this.$data.property.amenities, key.toString())
    },
    addService () {
      let newService = {
        description: '',
        free: false
      }
      let p = propertiesRef.child(this.$route.params.key).child('services').push(newService)
      p.then(payload => {
        this.addServiceKeyToProperty(payload.key, newService)
      })
    },
    deleteService (key) {
      this.$delete(this.$data.property.services, key.toString())
    },
    addServiceKeyToProperty (key, service) {
      if (!this.property.hasOwnProperty('services')) {
        this.$set(this.$data.property, 'services', {})
      }
      this.$set(this.$data.property.services, key.toString(), service)
    },
    addAmenityKeyToProperty (key, service) {
      if (!this.property.hasOwnProperty('amenities')) {
        this.$set(this.$data.property, 'amenities', {})
      }
      this.$set(this.$data.property.amenities, key.toString(), service)
    },
    loadCurrent () {
      propertiesRef.child(this.$route.params.key).once('value', snapshot => {
        this.property = snapshot.val()
      })
    },
    updateAddress (address) {
      this.$set(this.$data.property, 'address', address)
    }
  },
  watch: {
    '$route' () {
      this.loadCurrent()
    }
  },
  mounted () {
    this.loadCurrent()
  },
  components: {
    FeaturedImage,
    ServiceEditCard,
    inputTime,
    AddressEditPanel
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .gallery {
    margin: 16px;
  }

  .img-container {
    display: block;
    position: relative;
    width: 100%;
    padding-bottom: 100%;
  }

  .delete-button {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1;
  }

  .info-tab {
    position: absolute;
    bottom: 0px;
    height: 28px;
    width: 100%;
    padding: 4px;
    background-color: black;
    color: white;
    opacity: 0.71;
    z-index: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .image-div {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/PropertiesEdit.vue